import { Navigate } from 'react-router-dom'
import { useAppSelector } from '@/hooks/redux'
import Spinner from '@/components/Spinner'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Route guard that ensures user is authenticated
 * AuthInitializer handles the initial auth check globally
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth)

  // Wait for auth check to complete before deciding to redirect
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

